/*  MUI  */
import { Box, Button, Paper, Typography } from '@mui/material';

/*  React  */
import React from 'react';
import { useTranslation } from 'react-i18next';

import { ReportBuilder } from '../ReportBuilder';

export const UserSetsUpReportParams = ({
    ignoreParams,
    onChange,
    qbrToCBR,
    reportConfiguration,
    reportSetup,
    reportType,
    runReport
}) => {
    const { t } = useTranslation();

    const title =
        reportType === 'qbr' && qbrToCBR
            ? t('Common.cbr')
            : t(`Reports.Title.${reportType}.report`);

    return (
        <Paper
            elevation={0}
            variant="outlined"
            data-trackid="userSetsUpReportParams"
        >
            {!!reportType && (
                <Typography variant="h4" sx={{ fontWeight: 600 }}>
                    {title}
                </Typography>
            )}
            <ReportBuilder
                reportType={reportType}
                reportConfiguration={reportConfiguration}
                reportSetup={reportSetup}
                onChange={(newReportSetup) => {
                    onChange(newReportSetup);
                }}
                runFn={(newReportSetup) => {
                    runReport(newReportSetup);
                }}
                ignoreParams={ignoreParams}
            />
            <Box mb="8px">
                <hr />
                <Button
                    onClick={() => runReport()}
                    disabled={!reportSetup.type}
                    variant="contained"
                    color="primary"
                >
                    {t('Reports.run_report')}
                </Button>
            </Box>
        </Paper>
    );
};
